"use client";

import { BannerSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedBannerSection from "../Components/GeneratedBannerSection";

const Banner: FC<BannerSectionProps> = (props) => {
  return <GeneratedBannerSection {...props} />;
};

export default Banner;
